import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FC, useEffect, useMemo, useState } from "react";
import { UsuarioFamily } from "src/apis/eezyfamily";
import NoDataAlert from "src/pages/components/NoDataAlert";

const ROWS = 10;

type Props = {
  usuarios: UsuarioFamily[];
  onEdit: (item: UsuarioFamily) => void;
  onDelete: (id: number) => void;
};

const UsuariosTable: FC<Props> = ({
  usuarios,
  onEdit,
  onDelete,
}): JSX.Element => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const hasData = useMemo(
    () => Boolean(usuarios) && usuarios.length > 0,
    [usuarios]
  );
  const [entries, setEntries] = useState<UsuarioFamily[]>(usuarios);
  const [page, setPage] = useState(0);

  useEffect(() => {
    setEntries(usuarios);
    setPage(0);
  }, [usuarios]);

  const pageSlice = entries.slice(page * ROWS, page * ROWS + ROWS);

  if (!hasData) return <NoDataAlert />;

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Typography fontWeight={600}>Nome</Typography></TableCell>
              {!isSmall && <TableCell><Typography fontWeight={600}>Sobrenome</Typography></TableCell>}
              <TableCell><Typography fontWeight={600}>E-mail</Typography></TableCell>
              {!isSmall && <TableCell><Typography fontWeight={600}>Telefone</Typography></TableCell>}
              <TableCell><Typography fontWeight={600}>Colaborador ID</Typography></TableCell>
              <TableCell align="right"><Typography fontWeight={600}>Ações</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageSlice.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{item.name}</TableCell>
                {!isSmall && <TableCell>{item.surname ?? "—"}</TableCell>}
                <TableCell>{item.email}</TableCell>
                {!isSmall && <TableCell>{item.phone ?? "—"}</TableCell>}
                <TableCell>{item.collaborator_id ?? "—"}</TableCell>
                <TableCell align="right">
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => onEdit(item)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton size="small" onClick={() => onDelete(item.id)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={entries.length}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={ROWS}
        rowsPerPageOptions={[ROWS]}
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </>
  );
};

export default UsuariosTable;
